import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { IStreamDetails, IThemeConfig } from "../types/memorial-types";
import UserIcon from "./icons/user.svg";

import Subtitle from "./icons/subtitle.svg";

interface ServiceDetailsProps {
  stream: IStreamDetails;
  theme: IThemeConfig;
}

const ServiceDetails: React.FC<ServiceDetailsProps> = ({ stream, theme: _theme }) => {
  void _theme;
  const sermonTitle = stream.booking.events[0]?.title || "N/A";
  const pastor = `${stream?.service?.leader_preacher_name} ${stream?.service?.leader_preacher_surname}`;

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "20px",
        color: "#161515ff",
        backgroundColor: "#ffffffff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          textAlign: "left",
          borderRadius: "20px",
          px: { xs: 3, md: 5 },
          py: 2,
          boxShadow: 0,
        }}
      >
        {/* Title */}
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            fontWeight: "bold",
          }}
        >
          Service Details
        </Typography>

        {/* Content stacked vertically */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 1.2,
            fontSize: "1rem",
            opacity: 0.9,
          }}
        >
          {/* Sermon Title */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",

              gap: 5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <img
                src={Subtitle}
                alt="Subtitle Icon"
                style={{ width: 18, height: 18 }}
              />
              <Typography sx={{ fontWeight: 500 }}>Title:</Typography>
            </Box>
            <Typography>{sermonTitle}</Typography>
          </Box>

          {/* Pastor */}
          {stream?.booking?.service === "Church" && pastor?.trim() !== null && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 9,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img
                  src={UserIcon}
                  alt="User Icon"
                  style={{ width: 18, height: 18 }}
                />
                <Typography sx={{ fontWeight: 500 }}>Pastor:</Typography>
              </Box>
              <Typography>{pastor}</Typography>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default ServiceDetails;
